module.exports = __webpack_public_path__ + "img/list5.c7940f37.png";